import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';
import { ILoginResponsePacket, MessageFlags, ReturnCode, MessageType } from 'app/modules/remote-control-ng/definitions';

/** PC_LOGIN MessageType */
export class LoginMessage extends BaseMessage {
    public response: ILoginResponsePacket = <ILoginResponsePacket>{};

    constructor(private userName?: string) {
        super();
        this.userName = userName || '';
        this.header.command = MessageType.PC_LOGIN;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeStringLE(this.userName);
        buffer.writeStringLE("");
        buffer.writeInt32BE(15);
    }

    public deserializeBody(memoryBuffer: MemoryBuffer): void {
        let loginResponseInfo: ILoginResponsePacket = <ILoginResponsePacket>{};

        loginResponseInfo.returnCode = memoryBuffer.readUInt8();

        if (loginResponseInfo.returnCode == ReturnCode.PCR_OK) {
            const PayloadFlags = memoryBuffer.readUInt32BE();
            loginResponseInfo.hasScreenInfo = ((PayloadFlags & 1) != 0);
            loginResponseInfo.hasModelInfo = ((PayloadFlags & 2) != 0);
            if (loginResponseInfo.hasScreenInfo) {
                loginResponseInfo.width = memoryBuffer.readInt32BE();
                loginResponseInfo.height = memoryBuffer.readInt32BE();
                loginResponseInfo.rotation = memoryBuffer.readInt32BE();
            }

            let deviceModel:string;

            if (loginResponseInfo.hasModelInfo) {
                deviceModel = memoryBuffer.readString();
                var index = deviceModel.indexOf(".");
                index = deviceModel.indexOf(".", index + 1);
                deviceModel = deviceModel.substr(0, index);
            }
            if ((PayloadFlags & 4) != 0) {
                var filler = memoryBuffer.readInt32BE();
                filler = memoryBuffer.readInt32BE();

                loginResponseInfo.osType = memoryBuffer.readInt32LE();
            }
            loginResponseInfo.model = deviceModel;
        }
        this.response = loginResponseInfo;
    }
}
